<template>
  <div>
    <b-tabs small>
      <b-tab v-for="(e, i) in expeditions" :key="i" @click="displayTab(e.expedition)" small>
        <template v-slot:title>
          &nbsp;
          <span>
            {{ e.name }}
            <i :class="e.icon"></i>
            <b-badge :variant="e.color" style="position: relative">
              {{ e.cont }}
            </b-badge>
          </span>
          &nbsp;
        </template>
        <b-container fluid style="background-color: #fff">
          <FilterComponent :expedition="e" :options_por_conta="options_por_conta"
            :oprtions_available_channels="availableChannels" />
          <TablesComponent :filters="e.filters" :url="e.url" :url_next="e.url_next" :expedition="e.expedition"
            :checkFaturador="checkFaturador" :usr_orders="usr_orders" :showAll="showAll" :apps="apps" />
        </b-container>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import barramento from "../../../barramento";
import FilterComponent from "./Filter.vue";
import TablesComponent from "./Tables.vue";
export default {
  name: "Tabs",
  props: [
    "options_por_conta",
    "checkFaturador",
    "usr_orders",
    "availableChannels",
    "apps",
  ],
  components: { FilterComponent, TablesComponent },
  beforeMount() {
    for (var i = 0; i < this.expeditions.length; i++) {
      this.indexExpedition[this.expeditions[i].expedition] = i;
    }
  },
  beforeDestroy() {
    for (var i = 0; i < this.expeditions.length; i++) {
      barramento.$off("count_" + this.expeditions[i].expedition);
    }
  },
  created() {
    for (var i = 0; i < this.expeditions.length; i++) {
      barramento.$on("count_" + this.expeditions[i].expedition, (obj) => {
        this.expeditions[this.indexExpedition[obj.expedition]].cont = obj.valor;
      });
    }
  },
  methods: {
    displayTab(expedition) {
      this.showAll = expedition;
    },
  },
  data() {
    return {
      indexExpedition: [],
      showAll: "todos",
      expeditions: [
        {
          name: "Todos",
          expedition: "todos",
          icon: "fas fa-clipboard-list",
          cont: 0,
          color: "primary",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: null,
            sub_status: null,
          },
        },
        {
          name: "Despacho Incorreto",
          expedition: "despacho_incorreto",
          icon: "fas fa-window-close",
          cont: 0,
          color: "warning",
          url: "/api/orders/filter",
          url_next: "/api/orders/pagination/next/",
          filters: {
            status: "shipping_error",
            sub_status: null,
          },
        },
        {
          name: "Integração Incorreta",
          expedition: "integracao_incorreta",
          icon: "fas fa-bug",
          cont: 0,
          color: "danger",
          url: "/api/orders/error",
          url_next: "/api/orders/pagination/next/",
          filters: {
            //p_open: true,
            not_status: "canceled"
          },
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Tabs.vue